import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import oidc from 'App/redux/oidc/reducers'
import tenant from 'App/redux/tenant/reducers'
import headerActions from './headeractions/reducers'

export type TReducers = {
  [key: string]: (state: any | undefined, action: any) => any
}

export default (history: any, reducers?: TReducers) =>
  combineReducers({
    ...reducers,
    router: connectRouter(history),
    oidc,
    tenant,
    headerActions,
  })
